import React from "react";
import CRUD from "../CRUD/CRUD";
import ProposalInfo from "./ProposalInfo";
import { removeFile } from "../../requests/fileRequests";
import filter from "../../filter";
import { fetchData, mutateData } from "../Service/graphQlService";
import { CREATE_OR_PRICING_ANALYSIS, GET_PRICING_ANALYSIS } from "../Graphql/Queries/ProposalQuery";

function preProcess(data){
  return data.map((val)=>{
    if(val.__typename){
      delete val.__typename
    }
    return {
      ...val,
      items: val.items.map((item)=>{
        if(item.__typename){
          delete item.__typename
        }
        return item
      })
    }
})
}
function postProcess(data){
  return data.map((val)=>{
    if(val.__typename){
      delete val.__typename
    }
    return {
      ...val,
      items: val.items.map((item)=>{
        if(item.__typename){
          delete item.__typename
        }
        return item
      })
    }
})
}
export default class CRUDProposal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      isExists:false,
      errorTabs: [],
      users:[],
      currentTab: 0,
      updateProposal: false,
      viewMode: true,
      removedCards: [],
      accessPrompt: false,
      isVacant:{
        0:false,1:false,2:false,3:false,4:false,5:false,6:false
      }
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.saveData = this.saveData.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.setVacant = this.setVacant.bind(this)
  }
  

  componentDidMount() {
    this.fetch();
  }

  fetch() {
    this.setState({
      data: null,
      error: null,
      success: null,
    });
    let q = {
      AGENT_EMAIL: this.props.userData.email,
      // order:'ARCIMEDES_ROW_ID.asc'
    }
    const options = filter(q, 'pricing-analysis');
    return fetchData(GET_PRICING_ANALYSIS).then((res) => {
      if (res && res.data && res.data.getAllPricinganalysisData && Array.isArray(res.data.getAllPricinganalysisData)) {
        if(res.data.length === 0){
          this.setState({
            accessPrompt:true,
            data: [],
            original: []
          })
        }else{
          this.setState({
            data: preProcess(res.data.getAllPricinganalysisData),
            original: [...preProcess(res.data.getAllPricinganalysisData)],
            error: null,
          });
        }
      } 
      else {
        this.setState({
          data: false,
          error: res.message ? res.message : "Unidentified Error",
        });
      }
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (this.state.isBusy || this.state.viewMode === true) return;

    this.setState({ viewMode: true }, () => this.saveData());
  }

  saveData() {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    if(!this.state.updateProposal){
      this.setState({
        isBusy: null,
        error: "No changes were made",
        updateProposal: false,
      });
      return;
    }

    return  mutateData(CREATE_OR_PRICING_ANALYSIS,{ input: postProcess(this.state.data) }).then((res) => {
          if(res.data.responses){
            res = res.data.responses[0];
          }
        if (res && res.data && res.data.createOrUpdatePricingAnalysis && res.data.createOrUpdatePricingAnalysis.data && Array.isArray(res.data.createOrUpdatePricingAnalysis.data)) {
          this.setState(
            {
              isBusy: false,
              success: "Saved",
              updateProposal: false,
              data: preProcess(res.data.createOrUpdatePricingAnalysis.data),
              original: [...preProcess(res.data.createOrUpdatePricingAnalysis.data)],
            });
            this.state.removedCards.forEach((card) => {
              removeFile({fileName:card.name, FOLDER:'PRICING_ANALYSIS'})
            });
          window.scrollTo(0, 0);
        } else {
            this.setState({
              isBusy: null,
              error: res && res.message ? res.message : "Unspecified error",
              updateProposal: false,
            });
        }
      }
    );
  }

  handleChangeFile(value, index){
    let data = this.state.data;
    data[index].items = value;
    this.setState({data: data, updateProposal: true});
  }
  setVacant(index){
    let isVacant={
      ...this.state.isVacant,
      [index]: !this.state.isVacant[index]
    }
    this.setState({isVacant});
  }
  render() {

    if(this.state.accessPrompt){
      return (
        <div className='SuperAgent'>
            <h1>Not Authorized</h1>
            <p>Additional account permissions needed to view this page.</p>
        </div>
      )
    }

    const { isSuper} = this.props;
    let data = this.state.data;
    const tabsData = [
      {
        name: "INDUSTRIAL - MT",
        renderedComponent: (
            <ProposalInfo
                setState={this.setState.bind(this)}
                data={data && (!this.state.isVacant[0] ? data[0].items: data[7].items)}
                viewMode={this.state.viewMode}
                handleChangeFile={this.handleChangeFile}
                index={!this.state.isVacant[0]?0:7}
                isVacant={this.state.isVacant[0]}
                setVacant={()=>this.setVacant(0)}
                type='MT'
            />
        ),
      },
      {
        name: "INDUSTRIAL - STNL",
        renderedComponent: (
            <ProposalInfo
                setState={this.setState.bind(this)}
                data={data && (!this.state.isVacant[1]?data[1].items:data[8].items)}
                viewMode={this.state.viewMode}
                handleChangeFile={this.handleChangeFile}
                index={!this.state.isVacant[1]?1:8}
                isVacant={this.state.isVacant[1]}
                setVacant={()=>this.setVacant(1)}
                type='STNL'
            />
        ),
      },
      {
        name: "MULTI-FAMILY",
        renderedComponent: (
            <ProposalInfo
                setState={this.setState.bind(this)}
                data={data && (!this.state.isVacant[2]?data[2].items:data[9].items)}
                viewMode={this.state.viewMode}
                handleChangeFile={this.handleChangeFile}
                index={!this.state.isVacant[2]?2:9}
                isVacant={this.state.isVacant[2]}
                setVacant={()=>this.setVacant(2)}
                type='STNL'
            />
        ),
      },
      {
        name: "OFFICE - MT",
        renderedComponent: (
            <ProposalInfo
                setState={this.setState.bind(this)}
                data={data && (!this.state.isVacant[3]?data[3].items:data[10].items)}
                viewMode={this.state.viewMode}
                handleChangeFile={this.handleChangeFile}
                index={!this.state.isVacant[3]?3:10}
                isVacant={this.state.isVacant[3]}
                setVacant={()=>this.setVacant(3)}
                type='MT'
            />
        ),
      },
      {
        name: "OFFICE - STNL",
        renderedComponent: (
            <ProposalInfo
                setState={this.setState.bind(this)}
                data={data && (!this.state.isVacant[4]?data[4].items:data[11].items)}
                viewMode={this.state.viewMode}
                handleChangeFile={this.handleChangeFile}
                index={!this.state.isVacant[4]?4:11}
                isVacant={this.state.isVacant[4]}
                setVacant={()=>this.setVacant(4)}
                type='STNL'
            />
        ),
      },
      {
        name: "RETAIL - MT",
        renderedComponent: (
            <ProposalInfo
                setState={this.setState.bind(this)}
                data={data && (!this.state.isVacant[5]?data[5].items:data[12].items)}
                viewMode={this.state.viewMode}
                handleChangeFile={this.handleChangeFile}
                index={!this.state.isVacant[5]?5:12}
                isVacant={this.state.isVacant[5]}
                setVacant={()=>this.setVacant(5)}
                type='MT'
            />
        ),
      },
      {
        name: "RETAIL - STNL",
        renderedComponent: (
            <ProposalInfo
                setState={this.setState.bind(this)}
                data={data && (!this.state.isVacant[6]?data[6].items:data[13].items)}
                viewMode={this.state.viewMode}
                handleChangeFile={this.handleChangeFile}
                index={!this.state.isVacant[6]?6:13}
                isVacant={this.state.isVacant[6]}
                setVacant={()=>this.setVacant(6)}
                type='STNL'
            />
        ),
      }
    ];

    return (
      <CRUD
        tabsData={tabsData}
        isExists={this.state.isExists}
        router={this.props.router}
        edit={true}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={()=>this.saveData(true)}
        type="seller"
        title={'Proposals'}
        isSuper = {isSuper}
      />
    );
  }
}
